import { render, staticRenderFns } from "./LoadProofCertificatet.vue?vue&type=template&id=3a0a5faa&"
import script from "./LoadProofCertificatet.vue?vue&type=script&lang=js&"
export * from "./LoadProofCertificatet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports